<template>
<div class="col-12 px-0"> 

    <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="name" sortable :sort-method="sortColumnName" label="parceiro" min-width="80">
            <template slot-scope="scope">
                <div class="d-flex align-items-center">
                    <NameInitials :name="scope.row.name" :class="`c-ndarkfour`" small/>
                    <span :class="`c-ndarkfour break-name medium`">
                        {{ scope.row.name | formatName }}
                    </span>
                </div>
            </template>
        </el-table-column>

        <el-table-column prop="sponsors" sortable :sort-method="sortColumnBuyers" label="financiadores" min-width="60">
            <template slot-scope="scope">
                <span :class="`'c-ndarkfour' medium`">
                    {{ scope.row.sponsors.length }} {{ scope.row.sponsors.length == 1 ? 'financiador' : 'financiadores' }}
                </span>
            </template>
        </el-table-column>

        
        <el-table-column prop="orderFomentationRequest" min-width="180">
            <template slot-scope="scope">
                <div class="d-flex justify-content-end">
                    <el-dropdown trigger="click">
                        <Button type="secondary" size="small" :color="getPrimaryColor">Ações</Button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item>
                                <router-link :class="`${getPrimaryColor} c-ndarkthree medium d-flex justify-content-start`" :to="`partners/${scope.row.id}/edit`">
                                    <Edit/>Editar dados
                                </router-link>
                            </el-dropdown-item>

                            <el-dropdown-item>
                                <!-- <router-link :class="`${getPrimaryColor} c-ndarkthree medium d-flex justify-content-start`" :to="`partner/${scope.row.id}/edit`">
                                    <UsersIcon size="16" color="#A1A8B8"/>Gerenciar usuários
                                </router-link> -->
                                <span 
                                    :class="`${getPrimaryColor} c-ndarkthree medium pl-3 pr-3 d-flex align-items-center`"  
                                    @click="goToUsers(scope.row)"
                                >
                                    <UsersIcon size="16" color="#A1A8B8" class="mr-2" />Gerenciar usuários
                                </span>
                            </el-dropdown-item>

                            <el-dropdown-item divided>
                                <router-link :class="`${getPrimaryColor} c-ndarkthree medium d-flex justify-content-start`" :to="`partners/${scope.row.id}/sponsors`">
                                    <Banks class="mr-2" size="16" color="#A1A8B8"/>Gerenciar financiadores
                                </router-link>
                            </el-dropdown-item>

                            <el-dropdown-item>
                                <!-- <router-link :class="`${getPrimaryColor} c-ndarkthree medium d-flex justify-content-start`" :to="`partner/${scope.row.id}/edit`">
                                    <Settings />Regras de cobrança
                                </router-link> -->
                                <span   
                                    :class="`${getPrimaryColor} c-ndarkthree medium pl-3 pr-3 d-flex align-items-center`"
                                    @click="goToRules(scope.row)"
                                >
                                    <Settings class="mr-2"/>Regras da operação
                                </span>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
            </template>
        </el-table-column>
       
    </el-table>
    <GroupDelete :dialogVisible="dialogVisible" @closeModal="dialogVisible = $event" @deleteGroup="requestDeleteGroup"/>
    <EconomicGroupDeactivate :dialogVisible="dialogDeactivateVisible" @closeModal="dialogDeactivateVisible = $event" @deactivateGroup="changeGroupActivation(groupToChangeActivation)"/>
</div>
</template>

<script>
//ICONS:
import NameInitials from '@/components/icons/NameInitials'
import Banks from '@/components/icons/Banks'
import Edit from '@/components/icons/Edit'
import Settings from '@/components/icons/Settings'
import UsersIcon from '@/components/icons/Users'

import GroupDelete from '@/components/modals/GroupDelete'
import EconomicGroupDeactivate from '@/components/modals/EconomicGroupDeactivate'
import deleteEconomicGroup from '@/api/deleteEconomicGroup'
import updateEconomicGroupActivation from '@/api/updateEconomicGroupActivation'
import getCompany from '@/api/getCompany'

export default {
    props: {
        tableData: {
            required: true
        },
    },
    components: {
        Banks,
        NameInitials,
        Edit,
        Settings,
        GroupDelete,
        EconomicGroupDeactivate,
        UsersIcon,
    },
    data() {
        return {
            dialogVisible: false,
            dialogDeactivateVisible: false,
            groupToChangeActivation: {},
            groupIdToDelete: '',
            routeFromIsEditProvider: false,
        }
    },
    methods: {
        // sortColumnProviders(a, b) {
        //     return a.providers.length - b.providers.length
        // }, 
        sortColumnBuyers(a, b) {
            return a.buyers.length - b.buyers.length
        },
        sortColumnName(a, b) {
            return a.name.toLowerCase().localeCompare(b.name.toLowerCase())
        },
        handleDeleteGroup(id) {
            this.groupIdToDelete = id
            this.dialogVisible = true
        },
        async requestDeleteGroup() {
            const result = await deleteEconomicGroup(this.groupIdToDelete)
            if (result.data.ok) {
                this.$emit('groupDeleted')
            }
            this.dialogVisible = false
        },
        gotoDetails(row, column) {
            this.$emit('persistFilter')
            if (column.label) {
                this.$router.push(`group/${row.id}/edit`)
            }
        },
        async goToRules(partner) {
            if(partner.sponsors.length) {
                const mainSponsor = partner.sponsors.find(s => s.sponsorPartners.main)
            
                await getCompany({ cnpjId: mainSponsor.cnpjId, companyType: '0' })

                this.$router.push(`/partners/${partner.id}/sponsor/${mainSponsor.cnpjId}/rules`)
            }
        },
        async goToUsers(partner) {
            if(partner.sponsors.length) {
                const mainSponsor = partner.sponsors.find(s => s.sponsorPartners.main)
            
                await getCompany({ cnpjId: mainSponsor.cnpjId, companyType: '0' })

                this.$router.push(`/user/company/${mainSponsor.cnpjId}`)
            }
        },
        async handleActivationChange(row) {
            this.groupToChangeActivation = row
            if (row.economicGroupActive) {
                this.dialogDeactivateVisible = true
            } else {
                this.changeGroupActivation(row)
            }
        },
        async changeGroupActivation(row) {
            this.dialogDeactivateVisible = false
            const result = await updateEconomicGroupActivation(row.id, { economicGroupActivation: !row.economicGroupActive })
            if (result.data.ok) {
                this.$notify({
                    title: `Grupo econômico ${ row.economicGroupActive ? 'desativado' : 'ativado' } com sucesso!`,
                    message: '',
                    type: 'success',
                    duration: 3000,
                    offset: 100,
                    showClose: false,
                });
            }
            row.economicGroupActive = !row.economicGroupActive
        }
    },
}
</script>

<style lang="scss" scoped>
.partner-icon {
    stroke: none !important;
}
.el-table .el-table__body-wrapper .el-table__body tbody .el-table__row td .cell .el-dropdown {
    text-align: end !important;
}
</style>